import AsyncActionContainer, { AsyncActionContainerState } from '../AsyncActionContainer';
import { FormState, handleValueChange, updateFieldsValidation } from './Form';
import './Form.less';

export default class AsyncForm<P, S extends AsyncFormState> extends AsyncActionContainer<P, S> {
	constructor(props: unknown) {
		super(props);
		this.handleValueChange = this.handleValueChange.bind(this);

		this.state = {
			isValid: false,
			fieldsValidation: {},
			loading: false,
			errorMessage: null
		} as S;
	}

	handleValueChange(name: string, value: unknown, errorMessage: string) {
		// The code has to be exactly this way in order for it to be accesses via 'super' in subclasses.
		handleValueChange.apply(this, [name, value, errorMessage]);
	}

	updateFieldsValidation(name: string | number, fieldIsValid: boolean): boolean {
		return updateFieldsValidation.apply(this, [name, fieldIsValid]);
	}
}

export interface AsyncFormState extends FormState, AsyncActionContainerState {}
